function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amcharts/amcharts4/node_modules/@babel/runtime/helpers/arrayLikeToArray.js
// module id = 2976
// module chunks = 1